var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CreditCardPlanBox',{staticClass:"mt-2",attrs:{"brand":_vm.payment.data.brand,"entity":_vm.payment.data.entity,"plan":_vm.payment.data.plan,"order":_vm.order}})}
var staticRenderFns = []

export { render, staticRenderFns }